<!-- /系统配置-导航配置  -->
<template>
	<div>
		<div>
			<span>角色:</span>
			<el-select v-model="type_role" placeholder="请选择" @change="roleChange">
				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
				</el-option>
			</el-select>
		</div>
		<div style="margin: 10px 0 30px 0">
			<span>当前导航：</span>
			<span v-if="dataList.length>0"><span class="navItem" v-for="item in dataList" :key="item.id">{{
          item.nav_name
        }}</span></span>
			<span v-else class="noData">暂无数据</span>
		</div>
		<div>
			<span>编辑导航：</span>
			<span>
				<el-button type="success" @click="addNav">新增导航</el-button>
				<el-button type="success" @click="isSort = true">移动导航</el-button>
				<el-button type="success" @click="isDel = true">删除导航</el-button>
			</span>
			<div v-if="isShow">

				<div>
					<ul class="dataUl">
						<li style="justify-content: space-between; display: flex;"><span>名称</span><span>链接</span><span>级别/父级</span><span>链接类型</span><span>图标</span><span>底图</span></li>
						<li v-for="(item, index) in form" :key="index" style='justify-content: space-between; display: flex;'>
							<span>
								<el-input v-model="item.nav_name" placeholder="请输入名称"></el-input>
							</span><span>
								<el-input v-model="item.nav_url" placeholder="请输入网址"></el-input>
							</span>
							<span>
								<el-select v-model="item.nav_parent_code" style="width: 150px"
									@change="parentChange(item)">
									<el-option v-for="(item1,index1) in form1" :key="index1" :label="item1.nav_name"
										:value="item1.nav_code" :disabled="item1.nav_code == item.nav_code">
									</el-option>
								</el-select>
							</span>
							<span>
								<el-select v-model="item.nav_type" style="width: 150px" @change="parentChange(item)">
									<el-option v-for="(item2,index2) in form2" :key="index2" :label="item2.name"
										:value="item2.value">
									</el-option>
								</el-select>
							</span>
							<span>
								<upload :num='1' :index='index' :imgUrlArray='item.nav_ico' @imgUrlEmit='imgUrlEmit' style="overflow: hidden;width: 148px; height: 148px;"></upload>
							</span>
							<span>
								<upload :num='1'  :index='index' :imgUrlArray='item.nav_base_map' @imgUrlEmit='imgUrlEmittow' style="overflow: hidden;width: 148px; height: 148px;"></upload>
							</span>
							<i class="el-icon-circle-close del" v-if="isDel" @click="delNav(item,index)"></i>
							<i class="el-icon-top del" v-if="isSort" @click="sortNav(item,index)"></i>
						</li>
					</ul>
				</div>
				<div>
					<el-button type="success" @click="save">保存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		ConfigNavList,
		ConfigNavEdit,
		config_organization_nav_list,
		config_organization_nav_edit
	} from "../../../assets/js/network/network";
	import upload from "./upload.vue"
	export default {
		name: "ConfigNav",
		props: {
			disposeData: Object,
			ConfigSource:{
				type: String,
				default: 'null'
			},
		},
		components: {
			upload
		},
		data() {
			return {
				isShow: false,
				isSort: false,
				isDel: false,
				type_role: 2,
				options: [{
						id: 1,
						name: "学生"
					},
					{
						id: 2,
						name: "其它"
					},
				],
				form: [],
				form1: [{
					nav_name: "一级菜单",
					nav_code: '0',
				}],
				form2: [{
					name: "外链",
					value: 1,
				}, {
					name: "内链",
					value: 0,
				}],
				dataList: [],
			};
		},
		mounted() {
			this.getNavList(); //获取导航列表
		},
		methods: {
			//获取导航列表
			getNavList() {
				let data = {
					is_default: this.disposeData.is_default,
					organization_id: this.disposeData.organization_id,
					type_role: this.type_role
				}
				let requer=null;
				if(this.ConfigSource=='CourseOrganization'){
					requer=config_organization_nav_list(data)
				}else{
					requer=ConfigNavList(data)
				}
				requer.then((res) => {
					if (res.code == 0) {
						this.dataList = res.ret;
						this.form = JSON.parse(JSON.stringify(res.ret));
						this.form1 = [{
							nav_name: "一级菜单",
							nav_code: '0',
						}]
						this.form.forEach(item => {

							if(item.nav_ico==''){
								item.nav_ico=[];
							}else{
								item.nav_ico=[item.nav_ico];
							}
							if(item.nav_base_map==''){
								item.nav_base_map=[];
							}else{
								item.nav_base_map=[item.nav_base_map];
							}



							item.nav_parent_code = item.nav_parent_code ? item.nav_parent_code : '0'
							item.nav_code = item.nav_code ? item.nav_code : Date.parse(new Date()) + this
								.randomString(6)
							if (item.nav_parent_code == 0) {
								this.form1.push(item)
							}
						})
						if (this.form.length > 0) {
							this.isShow = true
						}
					}
				});
			},
			imgUrlEmit(item,index){
				console.log(item)
				if(item.length<=0){
					this.form[index].nav_ico=[];
				}else{
					this.form[item[0].index].nav_ico=[item[0].url];
				}

			},
			imgUrlEmittow(item,index){
				console.log(item,index)
				if(item.length<=0){
					this.form[index].nav_base_map=[];
				}else{
					this.form[item[0].index].nav_base_map=[item[0].url];
				}

			},
			roleChange(v) {
				//    console.log(v)
				this.getNavList(); //获取导航列表
			},
			randomString(e) {
				var e = e || 32,
					t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
					a = t.length,
					n = "";
				for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
				return n
			},
			//父级改变
			parentChange(item) {
				// console.log(item)
				this.form1 = []
				this.form1 = [{
					nav_name: "一级菜单",
					nav_code: '0',
				}]
				this.form.forEach(it => {
					if (it.nav_parent_code == 0) {
						this.form1.push(it)
					}
					if (item.nav_code == it.nav_parent_code) {
						it.nav_parent_code = item.nav_parent_code
					}
				})
			},

			//点击新增导航
			addNav() {
				this.isShow = true
				this.form.push({
					nav_name: "",
					nav_url: "",
					nav_ico:[],
					nav_base_map:[],
					organization_id: this.disposeData.organization_id,
					is_default: this.disposeData.is_default,
					type_role: this.type_role,
					// parent_id:0,
					sort: this.form.length,
					nav_type: 0,
					nav_code: Date.parse(new Date()) + this.randomString(6),
					nav_parent_code: '0',
				});
				this.form1 = [{
						nav_name: "一级菜单",
						nav_code: '0',
					}]
					this.form.forEach(item => {
						if (item.nav_parent_code == 0) {
							this.form1.push(item)
						}
					})
				//   console.log(this.form);
			},
			//点击删除
			delNav(item, index) {
				this.form.splice(index, 1);
				this.form.forEach(item1 => {
					item1.nav_parent_code = item.nav_code == item1.nav_parent_code ? '0' : item1.nav_parent_code
				})
			},
			//移动
			sortNav(item, index) {
				if (index != 0) {
					this.form.splice(index, 1)
					this.form.splice(index - 1, 0, item)
				} else {
					this.form.splice(index, 1)
					this.form.push(item)
				}
			},
			//保存
			save() {
				let data = {
					organization_id: this.disposeData.organization_id,
					is_default: this.disposeData.is_default,
					type_role: this.type_role,
					value_array: [],
				}
				this.form.map((item, index) => {
					data.value_array.push({
						nav_name: item.nav_name,
						nav_url: item.nav_url,
						nav_type: item.nav_type,
						nav_ico: item.nav_ico[0]?item.nav_ico[0]:'',
						nav_base_map: item.nav_base_map[0]?item.nav_base_map[0]:'',
						sort: index + 1,
						// parent_id:item.parent_id,
						// id:item.id,
						nav_code: item.nav_code,
						nav_parent_code: item.nav_parent_code
					})
				})
				console.log(data)
				let requer=null;
				if(this.ConfigSource=='CourseOrganization'){
					requer=config_organization_nav_edit(data)
				}else{
					requer=ConfigNavEdit(data)
				}
				requer.then(res => {
					if (res.code == 0) {
						console.log(res)
						this.isSort = false
						this.isDel = false
						this.$message.success("成功")
						this.getNavList(); //获取导航列表
					}
				})
			}
		},
	};
</script>
<style scoped>
	.dataUl {
		margin: 30px 0 0 80px;
	}

	.dataUl li {
		margin-bottom: 20px;
	}

	.dataUl li span:first-child {
		display: inline-block;
		width: 150px;
		margin-right: 50px;
	}

	.dataUl li span:nth-child(2) {
		display: inline-block;
		width: 200px;
	}

	.dataUl li span:nth-child(3) {
		display: inline-block;
		margin-left: 50px;
		width: 150px;
	}

	.dataUl li span:nth-child(4) {
		display: inline-block;
		margin-left: 50px;
		width: 150px;
	}

	.dataUl li span:nth-child(5) {
		display: inline-block;
		margin-left: 50px;
		width: 150px;
	}

	.dataUl li span:nth-child(6) {
		display: inline-block;
		margin-left: 50px;
		width: 150px;
	}

	.navItem {
		display: inline-block;
		width: 150px;
		border: 1px solid #ccc;
		text-align: center;
		padding: 10px 0;
		margin: 20px 30px 0 0;
		border-radius: 5px;
	}

	.del {
		cursor: pointer;
	}
</style>
